import type { NextPage } from 'next';
import styles from './UserComponent.module.scss';
import Button from 'componentsUnits/button';
import { followUser } from 'actions/activity';
import { Size } from 'types/size';
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks';
import Link from 'next/link';
import Break from 'componentsUnits/break';

interface Props {
  name: string;
  image?: string;
  id: string;
  subtitle?: string;
  numberOfEvents?: number;
  hideFollowButton?: boolean;
}

const UserComponent: NextPage<Props> = ({
  name = 'name',
  image,
  id,
  subtitle,
  hideFollowButton
}) => {
  const followedUsers = useAppSelector(state => state.activityReducer?.followedUsers);
  const dispatch = useAppDispatch();

  const isUserFollowed = (uid: string) => followedUsers?.includes(uid);

  const followUserClicked = (uid: string) => {
    dispatch(followUser(uid));
  };

  return (
    <div className={styles.container}>
      <Link href={`./profile?uid=${id}`} className={styles.imageWrapper}>
        <img
          src={image || '/emptyProfile.png'}
          alt={`${name}'s profile`}
          className={styles.image}
        />
      </Link>
      <div className={styles.infoWrapper}>
        <div className={styles.name}>{name}</div>
        <div className={styles.subtitle}>{subtitle}</div>
        <Break size={Size.xSmall} />
        {!hideFollowButton &&
          <Button
            size={Size.xxxSmall}
            type="7"
            text={isUserFollowed(id) ? 'Unfollow' : 'Follow'}
            onClick={() => followUserClicked(id)}
          />
        }
      </div>
    </div>
  );
};

export default UserComponent;
